import { isDefined } from 'utils/tsHelpers';
import { Combinator, CompleteQuery, ESIndex } from '../types';
import { convertToEditableQuery } from './convertToEditableQuery';
import { createBlankQueryForCatalog } from './createBlankQueryForCatalog';
import { createBlankQueryForUserAndEvent } from './createBlankQueryForUserAndEvent';

export const getDefaultQuery = (
  combinator: Combinator,
  esIndex: ESIndex,
  passedQuery?: CompleteQuery,
) => {
  if (isDefined(passedQuery))
    return convertToEditableQuery(passedQuery); // defined passed query
  else if (esIndex === ESIndex.UserAndEvent)
    return createBlankQueryForUserAndEvent(combinator); // esIndex is user and event
  else return createBlankQueryForCatalog(combinator); // esIndex is catalog
};
